//  Componente stateless per visualizzazione icona svg di Telegram
import React from 'react';

const TelegramIcon = () => {
  return (
    <svg role="graphics-symbol" aria-label="Telegram" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="telegram" transform="translate(4.000000, 6.316964)" fill='var(--social-icon)' fillRule="nonzero">
          <path d="M30.9100446,2.39419643 L26.2323661,24.4540179 C25.8794643,26.0109375 24.9591518,26.3984375 23.6513393,25.6649554 L16.5241071,20.4129464 L13.0850446,23.7205357 C12.7044643,24.1011161 12.3861607,24.4194196 11.6526786,24.4194196 L12.1647321,17.1607143 L25.3743304,5.22433036 C25.9486607,4.71227679 25.2497768,4.42857143 24.4816964,4.940625 L8.15133929,15.2232143 L1.12098214,13.0227679 C-0.408258929,12.5453125 -0.4359375,11.4935268 1.43928571,10.7600446 L28.9379464,0.166071429 C30.2111607,-0.311383929 31.3252232,0.449776786 30.9100446,2.39419643 Z" id="Shape" />
        </g>
      </g>
    </svg>
  );
};

export default TelegramIcon;
